import Loading from '../../../Common/Loading';
import {
    ServicesPerMonthPerYearTotal,
    ServicesPerYearTotal
} from '../../../Common/Services/charts/apex-charts';
import { useServicesChartsDataContext } from '../../../Common/Services/hooks/useServicesChartsDataContext';

const Total = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <ServicesPerYearTotal isMoney />
                <ServicesPerMonthPerYearTotal isMoney/>
            </div>
        </>
    );
};

export default Total;
